import React from 'react';
import Typography from '@mui/material/Typography';
import useStyles from './styles';

const CardSectionHeader = (props: CardSectionHeaderProps) => {
  const { sectionTitle, children } = props;
  const { classes } = useStyles();

  // Filter out invalid values (like empty objects from Storybook)
  const safeSectionTitle = typeof sectionTitle === 'string' ? sectionTitle : '';

  // Filter out invalid children (like empty objects from Storybook)
  const isValidChildren = (node: any): node is React.ReactNode => {
    if (node === null || node === undefined) return false;
    if (React.isValidElement(node)) return true;
    if (Array.isArray(node)) return true;
    if (typeof node === 'string' || typeof node === 'number') return true;
    // Filter out plain objects (like {} from Storybook)
    if (typeof node === 'object' && Object.keys(node).length === 0) return false;
    return false;
  };

  const safeChildren = isValidChildren(children) ? children : undefined;

  return (
    <div className={classes.root}>
      <Typography variant="caption" color="textSecondary">
        {safeSectionTitle}
      </Typography>
      {safeChildren}
    </div>
  );
};

export type CardSectionHeaderProps = {
  sectionTitle: string;
  children?: React.ReactNode;
};

export default CardSectionHeader;
